export default "__VITE_ASSET__ED5RWZiRiUmftnX9N4C5mw__"